import ShipperContracts from './styled';

export default ShipperContracts;
